import { FadeIn } from '~/components/ui/fade-in';

interface FeatureBlock {
  code: string;
  label: string;
  title: string;
}

interface TacticalDronesFeaturesSectionProps {
  left: FeatureBlock;
  right: FeatureBlock;
}

export const TacticalDronesFeaturesSection = ({
  left,
  right,
}: TacticalDronesFeaturesSectionProps) => {
  return (
    <section className="relative w-full flex flex-col md:flex-row md:items-end">
      {/* Left tile – layered graphite gradient over graphite-primary */}
      <div
        className="flex-1 bg-graphite-primary px-4 md:px-20 pt-5 pb-10 md:pt-10 md:pb-[60px] flex flex-col gap-2.5 md:items-end text-white"
        style={{ backgroundImage: 'linear-gradient(0deg, var(--color-graphite-dark) 0%, var(--color-graphite-dark) 100%)' }}
      >
        <FadeIn>
          <p className="font-mono text-sm leading-normal tracking-[0.14px] uppercase text-right w-full">
            {left.code}
          </p>
        </FadeIn>
        <FadeIn delay={0.1}>
          <div className="flex flex-col gap-3 w-full">
            <p className="font-mono text-sm leading-normal tracking-[0.14px] uppercase">
              {left.label}
            </p>
            <p className="text-xl font-normal leading-[1.4]">{left.title}</p>
          </div>
        </FadeIn>
      </div>

      {/* Right tile – black background */}
      <div className="flex-1 bg-black px-4 md:px-20 pt-5 pb-10 md:pt-10 md:pb-[60px] flex flex-col gap-2.5 md:items-end text-white">
        <FadeIn>
          <p className="font-mono text-sm leading-normal tracking-[0.14px] uppercase text-right w-full">
            {right.code}
          </p>
        </FadeIn>
        <FadeIn delay={0.1}>
          <div className="flex flex-col gap-3 w-full">
            <p className="font-mono text-sm leading-normal tracking-[0.14px] uppercase">
              {right.label}
            </p>
            <p className="text-xl font-normal leading-[1.4]">{right.title}</p>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};
